import {Button, Grid, ThemeProvider, Typography} from "@mui/material";
import theme from "../../../theme";
import {makeStyles} from "@mui/styles";
import SACCPaper from "../../../common/SACC/SACCPaper";
import useMediaQuery from '@mui/material/useMediaQuery';
import {useEffect, useState} from "react";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import {useAuth} from "../../../contexts/AuthContext";
import {basicStyle} from "../../../common/SACC/CareersFairContext/CFASStyles";
import {CFASHeader} from "../../../common/SACC/CareersFairContext/CFASHeader";
import {Colours, SamaggiTypography} from "../../../common/SamaggiTypography";
import {SamaggiButton} from "../../../common/SamaggiButton";


const useStyles = makeStyles(() => basicStyle);


const HubHome = (props) => {
    const classes = useStyles();

    const [loaded, setLoaded] = useState(false);
    const [cvLink, setCvLink] = useState("");
    const [transcriptLink, setTranscriptLink] = useState("");
    const [profileData, setProfileData] = useState({});
    const [firstLoad, setFirstLoad] = useState(true);
    const {getProfile, checkAttending} = useAuth();
    const [userAttending, setUserAttending] = useState(false);
    const [attendingLoading, setAttendingLoading] = useState(true);
    const [workExperience, setWorkExperience] = useState([]);

    function handleCVButton() {
        if (cvLink !== "") {
            console.log(cvLink);
            window.open(cvLink, "_blank");
        }
    }

    function handleTranscriptButton() {
        if (cvLink !== "") {
            console.log(transcriptLink);
            window.open(transcriptLink, "_blank");
        }
    }

    function getData() {

        // checkToken("/cfas/hub/home", userID, tokenID, secret);

        getProfile().then(async (res) => {
            const data = await res.json();
            if (res.status === 200) {
                setCvLink(data.data["cvLink"]);
                setTranscriptLink(data.data["transcriptLink"]);
                setProfileData(data.data);
                setWorkExperience(data.data["workExperience"] || []);
                console.log(data);
                props.setShowCover(false);
                setLoaded(true);
            } else if (res.status === 404 && (data.data["reason"] === "No Associated Profile Information" || data.data["reason"] === "Profile Information Not Found")) {
                window.location = "/cfas/hub/register";
            } else {
                alert(data.data["reason"]);
            }
        
        }).catch((error) => {
            console.log(error);
        });        

        setAttendingLoading(true);

        checkAttending().then(async (res) => {
            setAttendingLoading(false);
            const data = await res.json()
            if (res.status === 200) {
                setUserAttending(data.data["attending"]);
            } else {
                console.warn(data.data["reason"]);
            }
        }).catch((error) => {
            console.log(error)
        })

        
    }


    function goToTrack() {
        window.location = "/cfas/track/home";
    }

    function goToApply() {
        window.location = "/cfas/apply/home";
    }

    function goToEvent() {
        // window.location = "/cfas/event/register";
    }

    useEffect(() => {
        if (firstLoad) {
            getData();
            props.setShowCover(true);
            setFirstLoad(false);
        }
    })

    const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
    const profileIncomplete = !profileData["title"];

    return (
        <ThemeProvider theme={theme}>
            <Grid container direction="column" justifyContent="center" padding="100px" rowSpacing={6}>
                <CFASHeader>
                    Samaggi CFAS
                </CFASHeader>
                <Grid item>
                    <SACCPaper>
                        <Grid container direction={"row"} justifyContent={"space-between"}>
                            <Grid item container direction={"column"} xs={12} md={9}>
                                <Grid item>
                                    <SamaggiTypography gutterBottom variant="h6" xlarge bold>
                                        Profile
                                    </SamaggiTypography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h6" className={classes.text}>
                                        View and edit your CFAS profile.
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction={"column"} justifyContent={"space-evenly"} xs={12} md={3} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                <Grid item height={"fit-content"}>
                                    <SamaggiButton
                                        fullWidth
                                        endIcon={<ArrowRightAltIcon/>}
                                        onClick={() => { window.location = "/cfas/hub/register"; }}
                                    >
                                        View Profile
                                    </SamaggiButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>
                {profileData["title"] !== "" && (<>
                {!attendingLoading && !userAttending && <Grid item>
                    <SACCPaper>
                        <Grid container direction={"row"} justifyContent={"space-between"}>
                            <Grid item container direction={"column"} xs={12} md={9}>
                                <Grid item>
                                    <Typography gutterBottom variant="h6" className={classes.titleSmallMargin}>
                                        In-Person Event
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography gutterBottom variant="h6" className={classes.text} sx={{marginBottom: 0}}>
                                        Register for the In-Person Careers Fair Event
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction={"column"} justifyContent={"space-evenly"} xs={12} md={3} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                <Grid item height={"fit-content"}>
                                    <SamaggiButton fullWidth endIcon={<ArrowRightAltIcon/>} onClick={() => window.location = "/cfas/event/register"}>CFAS Event</SamaggiButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>}
                {!attendingLoading && userAttending && <Grid item>
                    <SACCPaper>
                        <Grid container direction={"row"} justifyContent={"space-between"} columnSpacing={3}>
                            <Grid item container direction={"column"} xs={12} md={9}>
                                <Grid item>
                                    <Typography gutterBottom variant="h6" className={classes.titleSmallMargin}>
                                        Registered for In-Person Event
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography gutterBottom variant="h6" className={classes.text} sx={{marginBottom: 0}}>
                                        You already have registered for the in-person Careers Fair event. You can view your ticket and profile share code at CFAS Event.
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction={"column"} justifyContent={"space-evenly"} xs={12} md={3} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                <Grid item height={"fit-content"}>
                                    <SamaggiButton fullWidth endIcon={<ArrowRightAltIcon/>}  onClick={() => window.location = "/cfas/event/home"}>CFAS Event</SamaggiButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>}
                </>)}
                {profileIncomplete && (<Grid item>
                    <SACCPaper>
                        <Grid container direction="column" spacing={5}>
                            <Grid item>
                                <SamaggiTypography xlarge center bold colour={Colours.darkGray}>You need to update your profile to continue.</SamaggiTypography>
                            </Grid>
                            <Grid item>
                                <SamaggiButton center fullWidth onClick={() => {window.location.href = "/cfas/hub/register"}}>Update Now</SamaggiButton>
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>)}

                {/* Apply card */}
                <Grid item height={"fit-content !important"}>
                    <SACCPaper sx={{overflow: "none"}}>
                        <Grid container direction={"row"} justifyContent={"space-between"}>
                            <Grid item container direction={"column"} xs={12} md={9}>
                                <Grid item>
                                    <SamaggiTypography gutterBottom variant="h6" xlarge bold>
                                        Apply
                                    </SamaggiTypography>
                                </Grid>
                                <Grid item>
                                    <Typography variant="h6" className={classes.text}>
                                        {cvLink === "" ? "You must upload a CV to access Apply." : "Apply to open positions and internships."}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction={"column"} justifyContent={"space-evenly"} xs={12} md={3}>
                                {profileIncomplete ? (
                                    <Grid item height={"fit-content"} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                        <SamaggiButton
                                            fullWidth
                                            endIcon={<ArrowRightAltIcon/>}
                                            onClick={goToApply}
                                            disabled
                                        >
                                            CFAS Apply
                                        </SamaggiButton>
                                    </Grid>
                                ) : (
                                    <>
                                        {cvLink !== "" && (
                                            <Grid item height={"fit-content"} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                                <SamaggiButton
                                                    fullWidth
                                                    endIcon={<ArrowRightAltIcon/>}
                                                    onClick={goToApply}
                                                >
                                                    CFAS Apply
                                                </SamaggiButton>
                                            </Grid>
                                        )}
                                        {cvLink === "" && (
                                            <Grid item height={"fit-content"} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                                <SamaggiButton
                                                    fullWidth
                                                    endIcon={<ArrowRightAltIcon/>}
                                                    onClick={() => {window.location = "/cfas/hub/register";}}
                                                >
                                                    Upload CV
                                                </SamaggiButton>
                                            </Grid>
                                        )}
                                    </>
                                )}
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>

                {/* Track card */}
                <Grid item >
                    <SACCPaper>
                        <Grid container direction={"row"} justifyContent={"space-between"}>
                            <Grid item container direction={"column"} xs={12} md={9}>
                                <Grid item>
                                    <SamaggiTypography gutterBottom variant="h6" xlarge bold>
                                        Track
                                    </SamaggiTypography>
                                </Grid>
                                <Grid item sx={{flexWrap: "no-wrap", overflowWrap: "no-wrap"}}>
                                    <Typography variant="h6" className={classes.text}>
                                        {cvLink !== "" ? "Track and view applications you've made." : "Make an application to access Track."}
                                    </Typography>
                                </Grid>
                            </Grid>
                            <Grid item container direction={"column"} justifyContent={"space-evenly"} xs={12} md={3} marginTop={largeScreen ? 0 : 3} marginBottom={largeScreen ? 0 : 3}>
                                {profileIncomplete ? (
                                    <Grid item height={"fit-content"}>
                                        <SamaggiButton
                                            fullWidth
                                            endIcon={<ArrowRightAltIcon/>}
                                            onClick={goToTrack}
                                            disabled
                                        >
                                            CFAS Track
                                        </SamaggiButton>
                                    </Grid>
                                ) : (
                                    cvLink !== "" && (
                                        <Grid item height={"fit-content"}>
                                            <SamaggiButton
                                                fullWidth
                                                endIcon={<ArrowRightAltIcon/>}
                                                onClick={goToTrack}
                                            >
                                                CFAS Track
                                            </SamaggiButton>
                                        </Grid>
                                    )
                                )}
                            </Grid>
                        </Grid>
                    </SACCPaper>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
};

export default HubHome;
